export default [
    {
        id: "account-management",
        icon: "account-management.svg",
        name: "Account Management",
        address: "https://myaccount.byu.edu/",
        heading: "University Account",
        tags: "settings"
    },
    {
        id: "account-recovery",
        icon: "account-recovery.svg",
        name: "Account Recovery",
        address: "https://accountrecovery.byu.edu/",
        heading: "University Account",
        tags: "settings forgot password"
    },
    {
        id: "apply-for-graduation",
        icon: "apply-for-graduation.svg",
        name: "Apply for Graduation",
        address: "https://y.byu.edu/ry/ae/prod/acad_plan/cgi/stdGraduationApp.cgi",
        heading: "Academics",
        tags: "senior diploma degree"
    },
    {
        id: "book-list",
        icon: "book-list.svg",
        name: "Book List",
        address: "https://booklist.byu.edu/Home/Mybooklist",
        heading: "My Classes",
        tags: "textbooks bookstore"
    },
    {
        id: "byusa",
        icon: "default.svg",
        name: "BYUSA",
        address: "https://byusa.byu.edu",
        heading: "Student Life",
        tags: "student association government clubs"
    },
    {
        id: "byu-speeches",
        icon: "byu-speeches.svg",
        name: "BYU Speeches",
        address: "https://speeches.byu.edu",
        heading: "Campus Resources",
        tags: "devotionals forums"
    },
    {
        id: "calendars",
        icon: "calendars.svg",
        name: "Calendars",
        address: "https://calendar.byu.edu",
        heading: "Student Life",
        tags: "devotionals forums events arts athletics sports"
    },
    {   // Deprecated
        id: "campus-directory",
        icon: "campus-directory.svg",
        name: "Campus Directory",
        address: "https://lambda.byu.edu/ae/prod/person/cgi/personLookup.cgi",
        heading: "Student Life",
        tags: "people faculty staff students"
    },
    {
        id: "campus-map",
        icon: "campus-map.svg",
        name: "Campus Map",
        address: "https://map.byu.edu",
        heading: "Student Life",
        tags: "buildings locations parking"
    },
    {
        id: "campus-shuttle",
        icon: "campus-shuttle.svg",
        name: "Campus Shuttle",
        address: "https://studentmovement.byu.edu/",
        heading: "Student Life",
        tags: "times transportation busses the ryde"
    },
    {
        id: "canvas",
        icon: "canvas.svg",
        name: "Canvas",
        address: "https://byu.instructure.com",
        heading: "My Classes",
        tags: "classes instructure assignments"
    },
    {
        id: "career-center",
        icon: "default.svg",
        name: "Career Center",
        address: "https://careers.byu.edu/",
        heading: "Campus Resources",
        tags: "jobs internships handshake employment"
    },
    {
        id: "class-schedule",
        icon: "default.svg",
        name: "Class Schedule",
        address: "https://commtech.byu.edu/noauth/classSchedule/index.php",
        heading: "My Classes",
        tags: "classes calendar time registration"
    },
    {
        id: "cougar-cash",
        icon: "cougar-cash.svg",
        name: "Cougar Cash",
        address: "https://sa.byu.edu/psc/ps/EMPLOYEE/HRMS/c/Y_MY_FINANCIAL_CENTER.Y_SIG_HOME_FL.GBL?Page=Y_SIG_HOME_FL",
        heading: "Student Life",
        tags: "classes instructure assignments"
    },
    {
        id: "counseling-services",
        icon: "default.svg",
        name: "Counseling Services",
        address: "https://caps.byu.edu/",
        heading: "Campus Resources",
        tags: "mental health stress diversity"
    },
    {
        id: "course-catalog",
        icon: "default.svg",
        name: "Course Catalog",
        address: "https://catalog.byu.edu/",
        heading: "My Classes",
        tags: "classes majors minors degrees requirements"
    },
    {
        id: "dining-account",
        icon: "dining-account.svg",
        name: "Dining Account",
        address: "https://housing.byu.edu/secure/services/dining/default.aspx",
        heading: "Student Life",
        tags: "meal plan balance housing"
    },
    {
        id: "dining-services",
        icon: "dining-services.svg",
        name: "Dining Services",
        address: "https://dining.byu.edu/",
        heading: "Student Life",
        tags: "food locations restaurants catering vending campus floral meal plans cougareat"
    },
    {
        id: "direct-deposit",
        icon: "direct-deposit.svg",
        name: "Direct Deposit",
        address: "https://sa.byu.edu/psc/ps/EMPLOYEE/SA/c/Y_MY_FINANCIAL_CENTER.Y_DDEP_OVERVW2_FL.GBL?Page=Y_DDEP_OVERVW2_FL&EMPLID=191786212",
        heading: "Employment",
        tags: "paycheck bank account financial"
    },
    {
        id: "ecclesiastical-endorsement",
        icon: "default.svg",
        name: "Eccl. Endorsement",
        address: "https://endorse.byu.edu",
        heading: "Academics",
        tags: "registration bishop"
    },
    {
        id: "enrollment-services",
        icon: "default.svg",
        name: "Enrollment Services",
        address: "https://enrollment.byu.edu/",
        heading: "Academics",
        tags: "registration dates policies schedule class cart"
    },
    {
        id: "employee-directory",
        icon: "campus-directory.svg",
        name: "Employee Directory",
        address: "https://lambda.byu.edu/ae/prod/person/cgi/personLookup.cgi",
        heading: "Campus Resources",
        tags: "people faculty staff"
    },
    {
        id: "finals-schedule",
        icon: "finals-schedule.svg",
        name: "Finals Schedule",
        address: "https://y.byu.edu/ry/ae/prod/class_schedule/cgi/examStudentSchedule.cgi",
        heading: "My Classes",
        tags: "testing"
    },
    {
        id: "financial-center",
        icon: "financial-center.svg",
        name: "Financial Center",
        address: "http://link.byu.edu/mfc",
        heading: "Academics",
        tags: "tuition payment account balance money charges"
    },
    {
        id: "get-software",
        icon: "get-software.svg",
        name: "Get Software",
        address: "http://software.byu.edu/",
        heading: "Technology",
        tags: "adobe download"
    },
    {
        id: "guest-access",
        icon: "guest-access.svg",
        name: "Guest Access",
        address: "https://guestaccess.byu.edu/",
        heading: "University Account",
        tags: "parents"
    },
    {
        id: "intramurals",
        icon: "intramurals.svg",
        name: "Intramurals",
        address: "https://intramurals.byu.edu/",
        heading: "Student Life",
        tags: "sports athletics student schedule rosters"
    },
    {
        id: "lab-computers",
        icon: "lab-computers.svg",
        name: "Lab Computers",
        address: "https://lib.byu.edu/services/public-computers/",
        heading: "Technology",
        tags: "computer labs library availability windows mac"
    },
    {
        id: "learn-anywhere",
        icon: "teach-anywhere.svg",
        name: "Learn Anywhere",
        address: "https://learnanywhere.byu.edu/",
        heading: "Academics",
        tags: "zoom online classes remote"
    },
    {
        id: "learning-suite",
        icon: "learning-suite.svg",
        name: "Learning Suite",
        address: "https://learningsuite.byu.edu",
        heading: "My Classes",
        tags: "classes assignments grades"
    },
    {
        id: "library",
        icon: "library.svg",
        name: "Library",
        address: "https://lib.byu.edu/",
        heading: "Academics",
        tags: "research books computers writing collections databases catalog study"
    },
    {
        id: "mymap",
        icon: "my-map.svg",
        name: "MyMap",
        address: "https://y.byu.edu/ry/ae/prod/mymap/cgi/summary.cgi",
        heading: "My Classes",
        tags: "classes registration plan class schedule"
    },
    {
        id: "off-campus-housing",
        icon: "default.svg",
        name: "Off-campus Housing",
        address: "https://och.byu.edu/",
        heading: "Student Life",
        tags: "apartments byu contracted housing"
    },
    {
        id: "oit",
        icon: "default.svg",
        name: "Office of IT",
        address: "https://oit.byu.edu",
        heading: "Technology",
        tags: "computers support services wifi classroom duo byu domains"
    },
    {
        id: "on-campus-housing",
        icon: "default.svg",
        name: "On-campus Housing",
        address: "https://housing.byu.edu/",
        heading: "Student Life",
        tags: "dorms helaman halls heritage halls wyview park wymount terrace flsr"
    },
    {
        id: "parking",
        icon: "parking.svg",
        name: "Parking",
        address: "https://security.byu.edu/parking-services",
        heading: "Student Life",
        tags: "parking pass vehicle registration parking map"
    },
    {
        id: "personal-information",
        icon: "personal-information.svg",
        name: "Personal Information",
        address: "https://gamma.byu.edu/ry/ae/prod/person/cgi/personSummary.cgi",
        heading: "University Account",
        tags: "name email phone number privacy"
    },
    {   // Deprecated
        id: "plan-courses",
        icon: "default.svg",
        name: "Plan Courses",
        address: "https://y.byu.edu/ry/ae/prod/mymap/cgi/plan.cgi",
        heading: "My Classes",
        tags: "degree program requirements schedule classes"
    },
    {
        id: "printers",
        icon: "printers.svg",
        name: "Printers",
        address: "https://lib.byu.edu/services/printers/",
        heading: "Technology",
        tags: "copy copier color black and white scanner"
    },
    {
        id: "progress-report",
        icon: "default.svg",
        name: "Progress Report",
        address: "https://advise.sim.byu.edu/",
        heading: "My Classes",
        tags: "degree program requirements classes"
    },
    {
        id: "register-for-classes",
        icon: "default.svg",
        name: "Register for Classes",
        address: "https://y.byu.edu/ry/ae/prod/mymap/cgi/register.cgi",
        heading: "My Classes",
        tags: "registration add drop waitlist wait list"
    },
    {
        id: "roc-pass",
        icon: "roc.svg",
        name: "ROC Pass",
        address: "https://tickets.byu.edu/roc",
        heading: "Student Life",
        tags: "sports athletics student tickets student section football basketball soccer"
    },
    {
        id: "scholarship-application",
        icon: "default.svg",
        name: "Scholarship Appl.",
        address: "https://sa.byu.edu/psp/ps/EMPLOYEE/HRMS/c/Y_SLR_STUDENT.Y_SLR_STU_APP_LAND.GBL",
        heading: "Academics",
        tags: "apply application tuition financial aid fasfa merit scholarships need based scholarships need-based scholarships"
    },
    {
        id: "scholarships",
        icon: "default.svg",
        name: "Scholarships",
        address: "https://sa.byu.edu/psc/ps/EMPLOYEE/SA/c/Y_MY_FINANCIAL_CENTER.Y_SLR_STU_ACT_FL.GBL",
        heading: "Academics",
        tags: "tuition financial aid fasfa merit scholarships need based scholarships need-based scholarships"
    },
    {
        id: "student-employment",
        icon: "default.svg",
        name: "Student Employment",
        address: "https://hrs.byu.edu/student-employment",
        heading: "Technology",
        tags: "student jobs on-campus jobs on campus jobs y-jobs work"
    },
    {
        id: "student-health",
        icon: "student-health.svg",
        name: "Student Health",
        address: "https://health.byu.edu/",
        heading: "Student Life",
        tags: "health plan insurance student health center medical medicine pharmacy"
    },
    {
        id: "teach-anywhere",
        icon: "teach-anywhere.svg",
        name: "Teach Anywhere",
        address: "https://teachanywhere.byu.edu/",
        heading: "Academics",
        tags: "zoom online classes remote"
    },
    {
        id: "testing-center",
        icon: "testing-center.svg",
        name: "Testing Center",
        address: "https://testing.byu.edu/",
        heading: "My Classes",
        tags: "exam finals assessment"
    },
    {
        id: "university-policies",
        icon: "default.svg",
        name: "University Policies",
        address: "http://policy.byu.edu/",
        heading: "Campus Resources",
        tags: "procedures administration honor code"
    },
    {
        id: "view-paycheck",
        icon: "view-paycheck.svg",
        name: "View Paycheck",
        address: "https://hrms.byu.edu/psp/ps/EMPLOYEE/HRMS/c/ROLE_EMPLOYEE.PY_IC_PAY_INQ.GBL?NAVSTACK=Clear",
        heading: "Employment",
        tags: "money employment paystub"
    },
    {
        id: "ymessage",
        icon: "y-message.svg",
        name: "Ymessage",
        address: "http://ymessage.byu.edu/",
        heading: "Academics",
        tags: "financial registration enrollment"
    },
    {
        id: "y-time",
        icon: "y-time.svg",
        name: "Y-Time",
        address: "https://hrms.byu.edu/psc/ps/EMPLOYEE/HRMS/c/NUI_FRAMEWORK.PT_MDSTARTPAGE_NUI.GBL?nRow=0&GMenu=Y_TL_PF&GComp=Y_TL_NAVLIST&GPage=Y_TL_NAVLIST&source=navcol",
        heading: "Employment",
        tags: "work job time clock in clock out"
    }
]